import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ProvinciasContext } from '../../../context/provincias/ProvinciasContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import SearchButton from "../../../components/SearchButton/SearchButton";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";

export const Datatable = ({ onSelect, onClose, enableCreate }) => {
  const titleGrid = "Lista de Provincias"
  useDocumentTitle(titleGrid);
const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(ProvinciasContext);
  const { deleteProvinciaData, getProvinciasPanelData } = contexto;
  const navigate = useNavigate();

  const nameData = "provincias";
  const descData = "pcia_descripcion";
  const getData = getProvinciasPanelData;
  const deleteData = deleteProvinciaData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState("");
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
//Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "provincias";
 // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchTerm: "",
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchTerm(savedFilters.searchTerm || "");
      setNumPagina(1);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, searchTerm,  numPagina, filas]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchTerm,
    };
    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage } = await fetchEntityData(
        getData,
        searchTerm,
        numPagina,
        filas
      );

      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };
  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const handleSearch = () => {
    const value = searchInputRef.current?.value || ""; // Obtiene el valor del input
    setSearchTerm(value); // Actualiza el estado con el término de búsqueda
  };

  const handleClear = () => {
    setSearchTerm("");
    if (searchInputRef.current) {
      searchInputRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const getDynamicValue = (row, key) => {
    return row[key];
  };

  const handleRowClick = (params) => {
    const selectedId = params.row.id; // Capturar el id del Cliente 
    const selectedDesc = getDynamicValue(params.row, descData);
    onSelect && onSelect(selectedId, selectedDesc); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden));
    return onSelect ? commonCols : commonCols.concat(getActionColumn(handleClickEdit, openModal));
  }, [onSelect, numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);


  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
          <FiltersGrid
            searchInputRef={searchInputRef}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearch={handleSearch}
            onClose={handleClear}
          />
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onRowClick={handleRowClick}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      )}
    </div>
  );
};

export default Datatable;
